/*
 * Copyright(c) 2022 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { PatientBannerItem } from './patient.types';

export class PatientBannerInfo {
  label: string;
  localLabel: string;
  data = [];

  constructor(name: string, iPatName: string, bannerData: PatientBannerItem[]) {
    this.label = name;
    this.localLabel = iPatName;

    const data = {};
    bannerData.forEach(bannerItem => {
      data[bannerItem.key] = bannerItem.value;
    });
    this.data.push(data);
  }
}
